import { useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';

const Layout = ({ 
  children, 
  currentPage = 'System Core',
  activeSection = 'dashboard',
  onSectionChange,
  onProfileClick,
  onProfileImageClick // New prop for profile image upload
}) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  const sidebarItems = [
    { id: 'dashboard', icon: 'grid_view', label: 'Dashboard' },
    { id: 'whatsapp', icon: 'phonelink_ring', label: 'Whatapp Instance' },
    { id: 'bulk-messaging', icon: 'send', label: 'Message Template' },
    { id: 'contacts', icon: 'person', label: 'Contacts' },
    { id: 'contact-groups', icon: 'group', label: 'Groups' },
    { id: 'blocked-users', icon: 'block', label: 'Block User' },
    { id: 'lid-mappings', icon: 'link', label: 'ID Resolution' },
    { id: 'user-management', icon: 'manage_accounts', label: 'Access Control' },
    { id: 'staff-management', icon: 'group_add', label: 'Staff Management' },
    { id: 'package-management', icon: 'inventory_2', label: 'Package Management' },
    { id: 'total-earnings', icon: 'trending_up', label: 'Earnings' },
    { id: 'order-management', icon: 'list_alt', label: 'Order Management' },
    { id: 'super-admin-management', icon: 'admin_panel_settings', label: 'Profile' },
  ];

  // Get current page title from sidebar items
  const getCurrentPageTitle = () => {
    const item = sidebarItems.find(item => item.id === activeSection);
    return item ? item.label : currentPage;
  };

  return (
    <div className="flex h-screen bg-[#fcfdfe] overflow-hidden font-sans">
      <Sidebar
        activeSection={activeSection}
        onSectionChange={onSectionChange}
        isCollapsed={isSidebarCollapsed}
        onToggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
        isMobileMenuOpen={isMobileMenuOpen}
        onCloseMobileMenu={closeMobileMenu}
      />

      {/* Main Content Area */}
      <main className="flex-1 flex flex-col min-w-0 h-full relative overflow-hidden">
        <Header
          currentPage={getCurrentPageTitle()}
          onProfileClick={onProfileClick}
          onMobileMenuToggle={() => setIsMobileMenuOpen(true)}
          onProfileImageClick={onProfileImageClick}
        />

        <div className="flex-1 overflow-y-auto custom-scrollbar bg-[#fcfdfe]">
          {children}
        </div>
      </main>
    </div>
  );
};

export default Layout;